import { Badge, Group, SimpleGrid, Stack, Text } from "@mantine/core";
import type { AssistantUsageLogText } from "@/locales/assistant-usage-log";
import type { UsageLogSummaryDto } from "@/types/ai-assistant-usage-log";
import {
	formatCount,
	formatPercent,
	VENDOR_COLOR,
	vendorLabel,
} from "./usage-log.logic";

interface Props {
	summary: UsageLogSummaryDto;
	t: AssistantUsageLogText;
	lang: "id" | "en";
}

/** Kartu ringkasan: porsi giliran Claude vs ChatGPT dan jumlah error per vendor pada rentang terpilih. */
export function UsageLogSummary({ summary, t, lang }: Props) {
	if (summary.totalTurns === 0)
		return (
			<Text size="sm" c="dimmed" data-usage-log-summary-empty>
				{t.summaryEmpty}
			</Text>
		);
	return (
		<Stack gap="xs" data-usage-log-summary>
			<Text fw={600} size="sm">
				{t.summaryTitle}
			</Text>
			<SimpleGrid cols={{ base: 1, sm: 3 }} spacing="xs">
				{summary.vendors.map((v) => (
					<Stack
						key={v.vendor}
						gap={2}
						data-usage-log-vendor={v.vendor}
						p="xs"
						style={{ borderRadius: 8 }}
						bg="var(--mantine-color-default-hover)"
					>
						<Group gap="xs">
							<Badge color={VENDOR_COLOR[v.vendor]} variant="light">
								{vendorLabel(v.vendor, t)}
							</Badge>
							<Text fw={600} size="sm">
								{t.summaryShare(formatPercent(v.percent, lang))}
							</Text>
						</Group>
						<Text size="xs" c="dimmed">
							{t.summaryTurns(formatCount(v.turns, lang))} ·{" "}
							{t.summaryErrors(formatCount(v.errors, lang))}
						</Text>
						<Text size="xs" c="dimmed">
							{t.summaryTokens(
								formatCount(v.inputTokens, lang),
								formatCount(v.outputTokens, lang),
							)}
						</Text>
					</Stack>
				))}
			</SimpleGrid>
		</Stack>
	);
}
